export default "__VITE_ASSET__BflGIXmp__"